import React from "react";

import Layout from "../components/verano2019Layout";

const Page = () => <Layout />;

export default Page;
